import type { Client, Conversation, Message, Participant, User as TwilioUser } from '@twilio/conversations';

export type ConversationState = 'active' | 'closed' | 'inactive' | string | undefined;

export enum EngagementPhase {
  PreEngagementForm = 'PreEngagementForm',
  Loading = 'Loading',
  MessagingCanvas = 'MessagingCanvas',
}

export interface ChatState {
  // Avoid storing raw client in Redux to keep state serializable; keep in component scope if needed
  // conversationsClient?: Client;
  conversation?: Conversation;
  conversationState?: ConversationState;
  connectionState?: string;
  users?: TwilioUser[];
  participants?: Participant[];
  messages?: Message[];
  attachedFiles?: File[];
}

export interface Token {
  token: string;
  conversationSid: string;
  expiration: number | string;
  engagementParameters?: Record<string, any>;
  bbc_id?: string;
  arion_route?: string;
}

